import {createTheme} from "@mui/material/styles";

export const mainTheme = createTheme({
    cssVariables: {
        colorSchemeSelector: 'data-toolpad-color-scheme',
    },
    colorSchemes: {
        light: {
            palette: {
                background: {
                    default: '#f8f7f6', // Main background for Box, Container
                    paper: '#f8f7f6',   // Background for Paper, Card, etc.
                    secondaryPaper: '#ffffff',
                },
            },
        },
        dark: true
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
});